import { Chips as PrimereactChips, ChipsProps } from 'primereact/chips';

import './style.css';

interface IChips extends ChipsProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
}

export const Chips: React.FC<IChips> = ({
    label,
    name,
    labelStyle,
    error,
    ...rest
}) => {
    return (
        <div className='custom-input-text'>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display : label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                </label>
                <PrimereactChips {...rest} />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-text-error'
                    >
                        {error}
                    </small>
                )}
            </span>
        </div>
    );
};